// extracted by mini-css-extract-plugin
module.exports = {"root":"InputSecondary_root__1TiWh","error":"InputSecondary_error__gv42U","disabled":"InputSecondary_disabled__2ywv-"};